import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  piKey: "AIzaSyCXQx9Bqjb_HY0FpzvVwoG3JAQY4QSxffg",
  authDomain: "centro-zeta.firebaseapp.com",
  databaseURL: "https://centro-zeta-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "centro-zeta",
  storageBucket: "centro-zeta.appspot.com",
  messagingSenderId: "58628494687",
  appId: "1:58628494687:web:08b6d50861df46ddcbd2ea"
};

// Inizializza Firebase solo se non è già stato inizializzato
const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);